import { createFileRoute } from "@tanstack/react-router";
import StaffTablePage from "@/pages/StaffTablePage";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/records/staff/"
)({
  component: StaffTablePage,
});
